function importAll(r) {
  return r.keys().map(r);
}

const France_L = importAll(require.context('../assets/photos/France_L', false, /\.(png|jpe?g|svg)$/));

export default France_L;